import { PROFILE_URL_PATH } from '@repo/ui';
import { GetAllCheckProfessionalExistsUseCaseInterface } from 'domain/usecases';
import { useService } from 'presentation/app/hooks/useService';
import { useNavigate, useParams } from 'react-router-dom';

export const usePreRegistration = () => {
  // hooks
  const navigate = useNavigate();
  const { professionalService } = useService();
  const { professionalType } = useParams<{
    professionalType: PROFILE_URL_PATH;
  }>();

  const handleCheckProfessionalExists = async (
    params: GetAllCheckProfessionalExistsUseCaseInterface.Params,
  ) => {
    return await professionalService
      .getAllCheckProfessionalExists(params)
      .then((res: GetAllCheckProfessionalExistsUseCaseInterface.Result) => {
        navigate(
          `/gerenciamento-de-profissional/${professionalType}/editar/${res.id}`,
        );
      })
      .catch(() => {
        navigate(`/gerenciamento-de-profissional/${professionalType}/novo`, {
          state: { id: '1', value: params.cpf },
        });
      });
  };

  return { handleCheckProfessionalExists };
};
